import BaseController from "confinus_ui/base_controller";

const HIDDEN_CLASS = "invisible";

export default class EntityUserFormController extends BaseController {
  public static targets = [
    "emailField",
    "emailConfirmationField",
    "emailConfirmationContainer",
    "currentPasswordContainer",
    "passwordField",
    "passwordConfirmationField",
    "passwordConfirmationContainer",
  ];

  public static values = {
    alwaysShowEmailConfirmation: Boolean,
    originalEmail: { type: String, default: null },
  };

  declare private readonly alwaysShowEmailConfirmationValue: boolean;
  declare private readonly originalEmailValue: string | null;

  declare private readonly emailFieldTarget: HTMLInputElement;
  declare private readonly emailConfirmationFieldTarget: HTMLInputElement;
  declare private readonly emailConfirmationContainerTarget: HTMLBaseElement;

  declare private readonly currentPasswordContainerTarget: HTMLBaseElement;
  declare private readonly hasCurrentPasswordContainerTarget: boolean;

  declare private readonly passwordFieldTarget: HTMLInputElement;
  declare private readonly hasPasswordFieldTarget: boolean;
  declare private readonly passwordConfirmationFieldTarget: HTMLInputElement;
  declare private readonly passwordConfirmationContainerTarget: HTMLBaseElement;

  public onInitialize() {
    this.handleEmailChange();
    this.handlePasswordChange();

    if (this.alwaysShowEmailConfirmationValue) {
      this.showEmailConfirmation();
    }

    return super.onInitialize();
  }

  public handleEmailChange() {
    if (this.alwaysShowEmailConfirmationValue) {
      return;
    }
    const emailFieldValue = this.emailFieldTarget.value;
    if (emailFieldValue !== this.originalEmail) {
      this.showEmailConfirmation();
      this.showCurrentPassword();
      return;
    }
    this.emailConfirmationFieldTarget.required = false;
    this.emailConfirmationContainerTarget.classList.add(HIDDEN_CLASS);
    this.hideCurrentPassword();
  }

  public handlePasswordChange() {
    if (!this.hasPasswordFieldTarget) {
      return;
    }
    const fieldValue = this.passwordFieldTarget.value;
    if (fieldValue != "") {
      this.passwordConfirmationFieldTarget.required = true;
      return this.passwordConfirmationContainerTarget.classList.remove(
        HIDDEN_CLASS,
      );
    }
    this.passwordConfirmationFieldTarget.required = false;
    this.passwordConfirmationContainerTarget.classList.add(HIDDEN_CLASS);
  }

  private showEmailConfirmation() {
    this.emailConfirmationFieldTarget.required = true;
    return this.emailConfirmationContainerTarget.classList.remove(HIDDEN_CLASS);
  }

  private showCurrentPassword() {
    if (this.hasCurrentPasswordContainerTarget) {
      this.currentPasswordContainerTarget.classList.remove(HIDDEN_CLASS);
    }
  }

  private hideCurrentPassword() {
    if (this.hasCurrentPasswordContainerTarget) {
      this.currentPasswordContainerTarget.classList.add(HIDDEN_CLASS);
    }
  }

  private get originalEmail(): string | null {
    const originalValue = this.originalEmailValue;
    if (originalValue === null) {
      return originalValue;
    }
    return originalValue as string;
  }
}
